import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UserRoleModel } from 'src/app/components/security/users/models/userRoleModel';
import { RoleModel } from 'src/app/components/security/roles/models/roleModel';
import { UserModel } from 'src/app/components/security/users/models/userModel';
import { environment } from 'src/environments/environment';
import { RestAPIService } from 'src/app/services/restapi.service';
import { ToastService } from 'src/app/services/toaster.service';

@Component({
    selector: 'app-userroles',
    templateUrl: './userroles.component.html'
})
export class UserRolesComponent implements OnInit {
    userId!: string;
    userRoleList: UserRoleModel[] = [];
    roleList: RoleModel[] = [];
    user: UserModel = new UserModel();

    displayedColumns = ['isChecked', 'name', 'description'];
    
    constructor(
        public _restAPI: RestAPIService, private toast: ToastService,
        private route: ActivatedRoute, 
        private router: Router) {
            this._restAPI.loading  = false;
            localStorage["applyUserRoleFilterValue"] = 'true';
        }

        //#region Get query params
        getQueryParams(): void {
            this.route
                .queryParams
                .subscribe(params => {
                    // Defaults to 0 if no query param provided.
                    let id = params['userId'] as string;
                    this.userId = id || '00000000-0000-0000-0000-000000000000';
                    if (this.userId == '00000000-0000-0000-0000-000000000000') {
                        this.router.navigateByUrl('/users');
                    }
                });
        }
        //#endregion
  
    async ngOnInit() {
        this.getQueryParams();
        await this.getUserRoleList();
        await this.getUserById();
    }
    
    async getUserById() {
        this._restAPI.loading  = true;
        this._restAPI.get<UserModel>(environment.apiURL + 'api/usermanagement/getbyid?id=' + this.userId).subscribe({
            next: (data) => {
                this._restAPI.loading  = false;
                this.user = data;
            },
            error: (error) => {this._restAPI.loading  = false;console.error(error)}
        });
    }

    async getUserRoleList() {
        this._restAPI.loading  = true;
        this._restAPI.get<UserRoleModel[]>(environment.apiURL + 'api/userrole/list/' + this.userId).subscribe({
            next: (data) => {
                this._restAPI.loading  = false;
                this.userRoleList = data;
                this.getRoleList();
            },
            error: (error) => {this._restAPI.loading  = false;console.error(error)}
        });
    }

    async getRoleList() {
        this._restAPI.loading  = true;
        this._restAPI.get<RoleModel[]>(environment.apiURL + 'api/role/list').subscribe({
            next: (data) => {
                this._restAPI.loading  = false;
                this.roleList = data;

                for (const role of this.roleList) {
                    const item = this.userRoleList.find(y => y.roleId == role.id);
                    role.isChecked = (item?.roleId?.length ?? 0) > 0;
                }
            },
            error: (error) => {this._restAPI.loading  = false;console.error(error)}
        });
    }

    async saveUserRole() {
        if (this.user.id != null && this.user.id.length > 0) {
            let postData = [];
            
            for (const role of this.roleList) {
                if (role.isChecked) {
                    postData.push({
                        id: '00000000-0000-0000-0000-000000000000',
                        userId: this.userId,
                        roleId: role.id
                    });
                }
            }
            this._restAPI.loading  = true;
            this._restAPI.put<string>(environment.apiURL + 'api/userrole/editbyuser/' + this.userId, postData).subscribe({
                next: (results) => {
                    this._restAPI.loading  = false;
                    this.toast.show("User role has been updated successfully");
                    this.router.navigateByUrl('/users');
                },
                error: (error) => {this._restAPI.loading  = false;console.error(error)}
            });
        }
    }
}